export default __webpack_public_path__ + "static/media/Laya_Vemulapalli - Laya Vemulapalli.8fb5812f.jpeg";